// Native Header Tabs Implementation
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Initializing navigation tabs...');
  
  // Function to initialize tabs for a specific dropdown
  function initializeTabs(dropdownSelector, dropdownName) {
    const dropdown = document.querySelector(dropdownSelector);
    if (!dropdown) {
      console.log(`${dropdownName} dropdown not found`);
      return;
    }

    const tabMenu = dropdown.querySelector('.nav_dropdown-menu.w-tab-menu');
    if (!tabMenu) {
      console.log(`Tab menu not found in ${dropdownName} dropdown`);
      return;
    }

    const tabButtons = tabMenu.querySelectorAll('.nav_tab-btn, .w-tab-link');
    const tabContent = dropdown.querySelector('.nav_dropdown-content, .w-tab-content');
    
    if (!tabContent) {
      console.log(`Tab content container not found in ${dropdownName}`);
      return;
    }
    
    const tabPanes = tabContent.querySelectorAll('.w-tab-pane');

    console.log(`${dropdownName} tabs found:`, tabButtons.length, 'buttons and', tabPanes.length, 'panes');

    // Tab switching functionality
    function switchTab(targetTab) {
      console.log(`🔄 Switching ${dropdownName} to tab:`, targetTab);
      
      // Remove active class from all buttons and panes
      tabButtons.forEach(btn => {
        btn.classList.remove('w--current');
        btn.setAttribute('aria-selected', 'false');
      });
      
      tabPanes.forEach(pane => {
        pane.classList.remove('w--tab-active');
      });

      // Add active class to target button and pane
      const targetButton = tabMenu.querySelector(`[data-w-tab="${targetTab}"]`);
      const targetPane = tabContent.querySelector(`[data-w-tab="${targetTab}"].w-tab-pane`);
      
      if (targetButton && targetPane) {
        targetButton.classList.add('w--current');
        targetButton.setAttribute('aria-selected', 'true');
        targetPane.classList.add('w--tab-active');
        
        console.log(`✅ ${dropdownName} tab switched successfully to:`, targetTab);
      } else {
        console.log(`❌ Could not find target button or pane for ${dropdownName}:`, targetTab);
      }
    }

    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        const targetTab = this.getAttribute('data-w-tab');
        console.log(`🎯 ${dropdownName} tab clicked:`, targetTab, `(index: ${index})`);
        switchTab(targetTab);
      });
      
      // Also add hover effect for better UX
      button.style.cursor = 'pointer';
    });

    console.log(`✅ ${dropdownName} tabs initialized successfully`);
  }
  
  
  // Initialize Matching Sets tabs
  initializeTabs('.matching_sets_dropdown', 'Matching Sets');
  
  console.log('✅ All navigation tabs initialized');
});
